goog.module('yext.developerapps.routes');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');

var route = _route;

const Dynamics365 = {
  saveWorkflow: route('dynamics365/save'),
  deleteWorkflow: route('dynamics365/workflows/:id'),
  listWorkflows: route('dynamics365/workflows'),
  sendTestTicket: route('dynamics365/testTicket'),
};

const ZendeskReviews = {
  saveWorkflow: route('zendeskreviews/save'),
  deleteWorkflow: route('zendeskreviews/workflows/:id'),
  listWorkflows: route('zendeskreviews/workflows'),
  sendTestTicket: route('zendeskreviews/testTicket'),
};

const HubspotReviewGen = {
  saveConfiguration: route('hubspotreviewgen/save'),
  saveNewField: route('hubspotreviewgen/createField'),
};

const SalesforceReviewGen = {
  saveConfiguration: route('salesforcereviewgen/save'),
  saveNewField: route('salesforcereviewgen/createField'),
};

const SalesforceReviews = {
  saveWorkflow: route('salesforcereviews/save'),
  deleteWorkflow: route('salesforcereviews/workflows/:id'),
  listWorkflows: route('salesforcereviews/workflows'),
  createTestCase: route('salesforcereviews/createTestCase'),
};

const SendGridReviewGen = {
  saveApiKey: route('sendgridreviewgen/configuration/saveApiKey'),
  configuration: route('sendgridreviewgen/configuration'),
  saveConfiguration: route('sendgridreviewgen/configuration/saveSettings'),
};

const InQuicker = {
  apiKey: route('inquicker/configuration/apiKey'),
  saveApiKey: route('inquicker/configuration/saveApiKey'),
};

const OloMenuSyncing = {
  apiKey: route('olomenusyncing/configuration/apiKey'),
  saveConfiguration: route('olomenusyncing/configuration/save'),
};

const WazeAdsSyncing = {
  view: route('wazeadssyncing/configuration/view'),
  save: route('wazeadssyncing/configuration/save'),
  syncNow: route('wazeadssyncing/syncNow'),
};

const RedoxReviewGen = {
  view: route('redoxreviewgen/configuration/view'),
  save: route('redoxreviewgen/configuration/save'),
};

const GoogleCalendarConnector = {
  view: route('googlecalendarconnector/selectCalendars'),
  save: route('googlecalendarconnector/saveCalendars'),
};

const KhorosDataConnector = {
  linkCommunities: route('khorosdataconnector/linkCommunities'),
  addCommunity: route('khorosdataconnector/addCommunity'),
  deleteCommunity: route('khorosdataconnector/deleteCommunity'),
};

const SlackDataConnector = {
  view: route('slackdataconnector/view'),
  saveChannels: route('slackdataconnector/saveChannels'),
  saveEntities: route('slackdataconnector/saveEntities'),
};

const SlackPrivateDataConnector = {
  view: route('slackprivatedataconnector/view'),
  saveChannels: route('slackprivatedataconnector/saveChannels'),
  saveEntities: route('slackprivatedataconnector/saveEntities'),
};


const DiscourseConnector = {
  view: route('discourseconnector/view'),
  save: route('discourseconnector/save'),
};

const FreshdeskConnector = {
  view: route('freshdeskconnector/configuration/view'),
  save: route('freshdeskconnector/configuration/save'),
};

const OloRestaurantConnector = {
  view: route('olorestaurantconnector/configuration/view'),
  linkAccounts: route('olorestaurantconnector/configuration/linkAccounts'),
};

const TableauConnector = {
  logMessage: route('tableauconnector/log'),
  getCookieToken: route('tableauconnector/cookie'),
  getSchema: route('tableauconnector/getSchema'),
  getCustomFields: route('tableauconnector/customFields'),
  getEntityData: route('tableauconnector/entities'),
  getSearchData: route('tableauconnector/search'),
  getAccountList: route('tableauconnector/accounts'),
  getMetricsData: route('tableauconnector/metrics'),
  getBingSearchData: route('tableauconnector/bingsearches'),
  getReviewsData: route('tableauconnector/reviews'),
  getFacebookListingsData: route('tableauconnector/facebooklistings'),
  getGoogleListingsData: route('tableauconnector/googlelistings'),
  getNewGoogleListingsData: route('tableauconnector/newgooglelistings'),
  getGooglePhoneCallsData: route('tableauconnector/googlephone'),
  getListingsData: route('tableauconnector/listings'),
  getPagesData: route('tableauconnector/pages'),
  getProfilesData: route('tableauconnector/profiles'),
  getReviewsAnalyticsData: route('tableauconnector/reviewsanalytics'),
  getSearchesData: route('tableauconnector/searches'),
  getSearchesClicksData: route('tableauconnector/searchesclicks'),
  getSearchCaseDeflectionData: route('tableauconnector/searchcasedeflection'),
  getGoogleListingsActions: route('tableauconnector/googlelistingsactions'),
  getGoogleSearchImpressions: route('tableauconnector/googlesearchimpressions'),
  getTotalListingsImpressions: route(
    'tableauconnector/totallistingsimpressions'),
  getGoogleCallsAnalytics: route('tableauconnector/googlecallsanalytics'),
  checkValidToken: route('tableauconnector/checkValidToken'),
  clearCookies: route('tableauconnector/clearCookies'),
  getAppUrl: route('tableauconnector/getAppUrl'),
  getOAuthUrl: route('tableauconnector/getOAuthUrl'),
  getClientId: route('tableauconnector/getClientId'),
  getWdcUrl: route('tableauconnector/getWdcUrl'),
};

const HealthcareTaxonomyConnector = {
  view: route('healthcaretaxonomy/view'),
  apiKey: route('healthcaretaxonomy/apiKey'),
  entityTypes: route('healthcaretaxonomy/entityTypes'),
  linkingModels: route('healthcaretaxonomy/linkingModels'),
  additionalResources: route('healthcaretaxonomy/additionalResources'),
  review: route('healthcaretaxonomy/review'),
  status: route('healthcaretaxonomy/status'),
  saveApiKey: route('healthcaretaxonomy/saveApiKey'),
  validateEntityTypes: route('healthcaretaxonomy/validateEntityTypes'),
  validateLinkingModel: route('healthcaretaxonomy/validateLinkingModel'),
  validateSearch: route('healthcaretaxonomy/validateSearch'),
  save: route('healthcaretaxonomy/save'),
  reset: route('healthcaretaxonomy/reset'),
};

/**
 * Helper method for routes, copied from js/yext/storm/router.js and modified for developerapp usage.
 *
 * @param {string} path within apps with placeholders
 * @return {function(object): string} to be called with key/values
 */
function _route(path) {
  return function(obj) {
    var pattern = '/apps/' + path;
    obj = obj || {};
    var queryParams = [];
    for (var key in obj) {
      var vals = obj[key];
      if (!Array.isArray(obj[key])) {
        vals = [obj[key]];
      }
      for (var i = 0; i < vals.length; i++) {
        var val = encodeURIComponent(vals[i]);
        var pattern2 = pattern.replace(':'+key, val);
        if (pattern == pattern2) {
          queryParams.push(key + '=' + val);
        }
        pattern = pattern2;
      }
    }
    if (queryParams.length > 0) {
      pattern += '?' + queryParams.join('&');
    }
    return pattern;
  };
}

exports = {
  Dynamics365,
  ZendeskReviews,
  HubspotReviewGen,
  SalesforceReviewGen,
  SalesforceReviews,
  SendGridReviewGen,
  InQuicker,
  OloMenuSyncing,
  WazeAdsSyncing,
  TableauConnector,
  RedoxReviewGen,
  GoogleCalendarConnector,
  SlackDataConnector,
  DiscourseConnector,
  FreshdeskConnector,
  KhorosDataConnector,
  OloRestaurantConnector,
  SlackPrivateDataConnector,
  HealthcareTaxonomyConnector,
};
